import React, { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from 'context/authContext';

import PrimaryButton from 'components/primaryButton';
import CreateProject from './createProject';
import ProjectCard from './projectCard';
import ProjectCardLoader from './projectCardLoader';

import { ReactComponent as NoProjectIlls } from 'assets/images/noProjectIlls.svg';

export default function ActiveProjects({
  getAllProjects,
  isModalOpen,
  setIsModalOpen,
}) {
  const [searchParams] = useSearchParams();

  const { authState } = useContext(AuthContext);

  return (
    <div className='pt-2'>
      {getAllProjects?.isLoading ? (
        // loader
        <div className='flex flex-wrap'>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
        </div>
      ) : (
        <>
          {getAllProjects?.data?.data?.length ? (
            <div className='flex flex-wrap '>
              {getAllProjects?.data?.data?.map((item) => (
                <div
                  key={item?.id}
                  className=' xl:w-1/3 lg:w-1/3  md:w-1/2 w-1/2 pr-4 pb-8 '
                >
                  <ProjectCard item={item} />
                </div>
              ))}
            </div>
          ) : (
            <div className='bg-white shadow-lg border border-gray border-opacity-10 min-h-[70vh] mt-2 rounded-lg'>
              <div className='flex flex-col justify-center items-center h-[70vh]'>
                <NoProjectIlls />
                <p className='text-gray3 text-xl pt-4'>
                  Seems like you don’t have any projects
                </p>
                {!authState?.is_admin && !authState?.is_subadmin ? null : (
                  <div>
                    {searchParams.get('priority') ||
                    searchParams.get('status') ||
                    searchParams.get('search') ? null : (
                      <button
                        className='mt-8'
                        onClick={() => setIsModalOpen(true)}
                      >
                        <PrimaryButton>+ Create project</PrimaryButton>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {/* create project modal */}
      {isModalOpen && (
        <CreateProject
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </div>
  );
}
